import * as React from 'react';
import FacetHeaderMobile from './FacetHeaderMobile/FacetHeaderMobile.js';

const FacetContainerMobile = ({ children , onClear , onSearch , refineCount , isActive ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "facet-container-mobile"
    }, !!isActive && /*#__PURE__*/ React.createElement(FacetHeaderMobile, {
        refineCount: refineCount,
        onSearch: onSearch,
        onClear: onClear
    }), /*#__PURE__*/ React.createElement("div", {
        className: "facet-container-mobile__inner"
    }, children));
};
var FacetContainerMobile$1 = FacetContainerMobile;

export { FacetContainerMobile$1 as default };
//# sourceMappingURL=FacetContainerMobile.js.map
